import React, { useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import DonationForm from './components/DonationForm';
import AnnReg from './pages/AnnReg';
import AnniversaryDinner from './pages/AnniversaryDinner';
import ThankYou from './pages/ThankYou';

function App() {
  let path = typeof window !== 'undefined' ? window.location.pathname.toLowerCase() : '/';
  // Collapse multiple slashes to a single slash for robust matching (e.g., //hyc -> /hyc)
  path = path.replace(/\/+/, '/');
  const isHome = path === '/' || path === '';
  const isHYC = /^\/hyc(\/+|$)/.test(path);
  const isRMS = /^\/rms(\/+|$)/.test(path);
  // Anniversary Registration page supports /annver (requested), /annreg (back-compat), and /anner (alias)
  const isAnnReg = /^(?:\/annver|\/annreg|\/anner)(\/+|$)/.test(path);
  const isThankYou = /^\/thankyou(\/+|$)/.test(path);
  const showBanner = isAnnReg || isHYC || isRMS; // No banner for home (dinner) or thank-you
  const bannerTitle = isAnnReg
    ? 'Anniversary Registration'
    : (isHYC ? 'Donation For Harmony Youth Center' : 'Donation For Radha Madhav Society');
  const subtitle = isAnnReg ? 'RSVP for Anniversary Dinner' : 'Make a secure online contribution';

  // Set document title and favicon based on route
  useEffect(() => {
    if (typeof document !== 'undefined') {
      const pageTitle = isHome
        ? 'Anniversary Dinner'
        : isThankYou
          ? 'Thank You'
          : (isAnnReg ? 'Anniversary Registration' : (isHYC ? 'HYC Donation' : (isRMS ? 'RMS Donation' : 'Yugal Kunj')));
      document.title = `Yugal Kunj - ${pageTitle}`;
      const setFavicon = (href: string) => {
        let link = document.querySelector("link[rel='icon']") as HTMLLinkElement | null;
        if (!link) {
          link = document.createElement('link');
          link.rel = 'icon';
          document.head.appendChild(link);
        }
        link.href = href;
      };
      // Use Yugal Kunj logo for all pages to replace React icon
      const YK_LOGO = 'https://stssevastorage.blob.core.windows.net/ykwebsite/logo.png';
      setFavicon(YK_LOGO);
    }
  }, [isHome, isThankYou, isAnnReg, isHYC, isRMS]);
  return (
    <div className="App">
      {/* Banner and Navigation (only for donation & registration pages) */}
      {showBanner && (
        <div className="banner">
          <h1>{bannerTitle}</h1>
          <p className="subtitle">{subtitle}</p>
        </div>
      )}

      {/* Donation Form Component */}
      {isHome ? (
        <AnniversaryDinner />
      ) : isThankYou ? (
        <ThankYou />
      ) : isAnnReg ? (
        <AnnReg />
      ) : isHYC ? (
        <DonationForm
          entity="HYC"
          emailAppName="Donation"
          emailTemplateName="HYCDonation"
          title="Donation for Harmony Youth Center"
        />
      ) : isRMS ? (
        <DonationForm
          entity="RMS"
          emailAppName="Donation"
          emailTemplateName="RMSDonation"
          title="Donation for Radha Madhav Society" />
      ) : (
        <AnniversaryDinner />
      )}
    </div>
  );
}

export default App;
